function toNullable(maybe) {
    return maybe.match({
        Just: function (val) { return val; },
        Nothing: function () { return null; },
    });
}
export { toNullable };
